import React from 'react'
import './Works.css';
import Bootstrap33 from "../../img/Bootstrap33.png";
import React3 from "../../img/React3.png";
import Replit1 from "../../img/Replit1.png";
import Node3 from "../../img/Node3.png";
import Mongodb from "../../img/Mongodb.png";
import { themeContext } from '../../Context';
import {Link} from 'react-scroll';
import { useContext } from 'react';
const Works = () => {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode
    return (
        <div className="works">
            <div className="awesome">
                <span style={{ color: darkMode ? 'white' : '' }}>"Works" on all </span>
                <span>these Technologies</span>
                <span>
                    I build a lots of responsive template . Some of them is clone
                    <br />
                    of popular website. I build my own three - four portfolio
                    <br />
                    website using these Technologies and deploy on Github
                    <br />
                    and Netlify Plateform. I also build React projects
                    <br />
                    and real life working website clone. I worked
                    <br />
                    with college about to build website for
                    <br />
                    student services.
                </span>
                <Link spy={true} to='Contact-form' smooth={true}>
                <button className="button s-button">Hire me</button>
                </Link>
                <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
            </div>
            {/* Right side */}
            <div className="w-right">
                <div className="w-mainCircle">
                    <div className="w-secCircle">
                        <img src={Bootstrap33} alt="" />
                    </div>
                    <div className="w-secCircle">
                        <img src={React3} alt="" />
                    </div>
                    <div className="w-secCircle">
                        <img src={Replit1} alt="" />
                    </div>
                    <div className="w-secCircle">
                        <img src={Node3} alt="" />
                    </div>
                    <div className="w-secCircle">
                        <img src={Mongodb} alt="" />
                    </div>
                </div>
                <div className="w-backCircle blueCircle"></div>
                <div className="w-backCircle yellowCircle"></div>
            </div>
        </div>
    )
}

export default Works
